import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export const marginX = config => {
  return [{
    config: _objectSpread({}, config),
    property: "marginLeft"
  }, {
    config: _objectSpread({}, config),
    property: "marginRight"
  }];
};
export const marginY = config => {
  return [{
    config: _objectSpread({}, config),
    property: "marginTop"
  }, {
    config: _objectSpread({}, config),
    property: "marginBottom"
  }];
};
export const paddingX = config => {
  return [{
    config: _objectSpread({}, config),
    property: "paddingLeft"
  }, {
    config: _objectSpread({}, config),
    property: "paddingRight"
  }];
};
export const paddingY = config => {
  return [{
    config: _objectSpread({}, config),
    property: "paddingTop"
  }, {
    config: _objectSpread({}, config),
    property: "paddingBottom"
  }];
};

/**
 * General colors - Brand colors - add in tailwind.config.js
 */

// #Region: New interfaces